<script>
	import API from '../../States/API';
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Router from '../../States/Router';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';
	import Sun from '../../Models/Sun';
	import Trigger from '../../Models/Trigger';

	function property(name) {
		var style = window.getComputedStyle(document.body);
		return style.getPropertyValue(`--${name}`);
	}

	function themeHTML() {
		if (!$Session.theme.fixed) {
			const now = new Date();
			const amsterdam = [52.378, 4.897];
			const sunrise = Sun.sunrise(...amsterdam);
			const sunset = Sun.sunset(...amsterdam);
			const light = (now > sunrise) && (now < sunset);

			$Session.theme.code = light ? 'light' : 'dark';
			$Session.theme.dark = !light;
		}

		themeChange();
	}

	function themeChange() {
		const add = $Session.theme.dark ? 'dark' : 'light';
		const remove = $Session.theme.dark ? 'light' : 'dark';
		jQuery('html').addClass(add).removeClass(remove);
	}

	function themeBackground() {
		var background = property('background');
		jQuery('meta[name=theme-color]').attr('content', background);
	}

	function platform() {
		const ios = Helper.ios();
		const android = Helper.android();
		const platform = ios ? 'ios' : (android ? 'android' : 'browser');
		jQuery('html').attr('data-platform', platform);
	}

	function init() {
		platform();
		themeHTML();
		themeBackground();
	}

	async function chapters() {
		const version = await Data.relative('version');
		const base = version.testaments[0].books.concat(version.testaments[1].books);
		const books = base.sort((a, b) => { return (a.name < b.name) ? -1 : 1 });

		let index = 0;
		let chapter = 0;
		if (Helper.is($Slider.slide_5.properties)) {
			const reading = $Slider.slide_5.properties.chapter.split('_');
			chapter = reading[1];
			for (let book_index in books)
				if (books[book_index].code == reading[0]) {
					index = book_index;
					break;
				}
		}

		if (chapter) {
			Router.push(`/${books[index].uri}`);
			Slider.chapters(books[index].code, chapter);
		}
	}

	Trigger.subscribe('theme', state => {
		themeChange();
		themeBackground();
	});

	init();
</script>

<style>
	#header {
		padding: 1.5em 10vw .75em 10vw;
		border-bottom: 1px solid rgba(0, 0, 0, .05);
	}

	i {
		font-size: 1.5em;
		color: var(--primary-color);
		cursor: pointer;
		--fa-secondary-color: var(--secondary-color);
		--fa-secondary-opacity: .9;
	}

	i.fa-bars {
		--fa-secondary-opacity: 1;
	}

	div.toggle > span.toggle-menu {
		width: 1.25em;
		margin-top: 3.1em;
		margin-right: 1em;
		vertical-align: top;
		display: inline-block;
	}

	div.toggle {
		display: inline-block;
		cursor: pointer;
	}

	div.toggle a {
		display: inline-block;
	}

	div.toggle a.toggle-start.BB img {
		width: 10em;
	}

	div.toggle a.toggle-start.VB img {
		margin-top: 1.75em;
		margin-bottom: .2em;
		margin-left: .5em;
		width: 12em;
	}

	div.menu {
		display: inline-block;
		float: right;
	}

	div.menu div {
		display: inline-block;
		margin: 3em 0 0 1.5em;
		cursor: pointer;
	}

	div.menu i {
		font-size: 1.25em;
		color: var(--tertiary-color);
		margin-right: .4em;
		--fa-primary-opacity: .55;
		--fa-secondary-color: var(--tertiary-color);
		--fa-secondary-opacity: .9;
	}

	div.menu span {
		font-weight: 700;
	}

	@media (max-device-width: 767px) {
		div.hide-mobile,
		div.hide-tablet {
			display: none !important;
		}

		div.menu div {
			margin: 1.9em 0 0 1.1em;
		}

		div.menu i {
			font-size: 1.2em;
			margin-right: 0;
		}

		div.menu span {
			display: none;
		}
	}

	@media (max-device-width: 1024px) {
		div.hide-tablet {
			display: none !important;
		}

		#header {
			padding: .75em 6vw .5em 6vw !important;
		}

		div.toggle a.toggle-start.BB img {
			width: 7em !important;
		}

		div.toggle a.toggle-start.VB img {
			margin-top: 1.4em !important;
			margin-bottom: .45em !important;
			margin-left: .5em !important;
			width: 6.5em !important;
		}

		div.toggle span.toggle-menu {
			margin-top: 1.85em !important;
		}
	}

	@media (min-device-width: 768px) and (max-device-width: 1024px) {
		div.menu div {
			margin: 1.9em 0 0 1.5em !important;
		}
	}
</style>

<div id="header">
	<div class="toggle" on:click="{event => Session.toggleMenu()}">
		<span class="toggle-menu">
			<i class="fad fa-bars"></i>
		</span>
		{#if !$Data.version.beta}
			<a class="toggle-start {$Data.version.code}">
				<img class="light" src="./media/logo/{$Data.version.code}/light.svg" alt="Logo"/>
				<img class="dark" src="./media/logo/{$Data.version.code}/dark.svg" alt="Logo"/>
			</a>
		{/if}
	</div>
	<div class="menu">
		<div on:click="{event => Session.toggleTheme()}">
			<i class="fad fa-lightbulb-{$Session.theme.dark ? 'on' : 'slash'} smaller"></i>
			<span>{$Session.theme.dark ? 'Licht' : 'Donker'}</span>
		</div>
		<div class="hide-tablet" on:click="{event => Slider.route('start')}">
			<i class="fad fa-home-alt"></i>
			<span>Start</span>
		</div>

		{#if $Slider.active.properties.type != 'chapter'}
			<div class="hide-mobile" on:click="{event => Slider.route('read')}">
				<i class="fad fa-book-open"></i>
				<span>Lezen</span>
			</div>
		{:else}
			<div on:click="{event => chapters()}">
				<i class="fad fa-books"></i>
				<span>Boek kiezen</span>
			</div>
			<div on:click="{event => Slider.index()}">
				<i class="fad fa-sort-alpha-down"></i>
				<span>Boeken</span>
			</div>
		{/if}

		<div on:click="{event => Slider.route('search')}">
			<i class="fad fa-search"></i>
			<span>Zoeken</span>
		</div>
		{#if $Session.authentication.active}
			<div on:click="{event => Slider.route('favorite')}">
				<i class="fad fa-book-heart"></i>
				<span>Favorieten</span>
			</div>
		{/if}
		{#if $API.active}
			{#if $Session.authentication.active}
				<div on:click="{event => Slider.signOut()}">
					<i class="fad fa-sign-out"></i>
					<span>Uitloggen</span>
				</div>
			{:else}
				<div on:click="{event => Slider.route('signIn')}">
					<i class="fad fa-user"></i>
					<span>Inloggen</span>
				</div>
			{/if}
		{/if}
	</div>
</div>